// File: src/pages/candidate/PreExamCheckPage.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';


// --- ICONS SVG ---
const IconCheckCircle = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-green-600"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>;
const IconMic = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path><path d="M19 10v2a7 7 0 0 1-14 0v-2"></path><line x1="12" y1="19" x2="12" y2="23"></line><line x1="8" y1="23" x2="16" y2="23"></line></svg>;
const IconWarning = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-amber-500"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>;
const IconHeadsetOff = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-red-500"><path d="M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5Zm0 0a9 9 0 1 1 18 0m0 0v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3Z"></path><line x1="3" y1="3" x2="21" y2="21"></line></svg>; // Icon minh họa
const IconTabOff = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-red-500"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="3" y1="9" x2="21" y2="9"></line><line x1="9" y1="21" x2="9" y2="9"></line></svg>;
const IconFace = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-blue-500"><circle cx="12" cy="12" r="10"></circle><line x1="8" y1="15" x2="16" y2="15"></line><line x1="9" y1="9" x2="9.01" y2="9"></line><line x1="15" y1="9" x2="15.01" y2="9"></line></svg>;
const IconPersonOff = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-red-500"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="23" y1="11" x2="17" y2="11"></line></svg>;
const IconArrowForward = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>;
const IconCamera = () => <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" className="text-gray-400"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path><circle cx="12" cy="13" r="4"></circle></svg>;

export default function PreExamCheckPage() {
  const { id } = useParams(); // Lấy ID bài test từ URL
  const navigate = useNavigate();
  const videoRef = useRef(null);
  const streamRef = useRef(null);

  const [hasPermission, setHasPermission] = useState(false);
  const [stream, setStream] = useState(null);
  const [isAgreed, setIsAgreed] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  // 1. Tự động xin quyền Camera khi vào trang
  useEffect(() => {
    const getMedia = async () => {
      try {
        const mediaStream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
        
        // Lưu vào Ref ngay lập tức (Ref không bị mất giá trị khi đóng hàm)
        streamRef.current = mediaStream; 
        
        setStream(mediaStream); // Lưu vào state để cập nhật giao diện
        
        if (videoRef.current) {
          videoRef.current.srcObject = mediaStream;
        }
        setHasPermission(true);
      } catch (err) {
        console.error("Lỗi Camera:", err);
        setErrorMsg('Không thể truy cập Camera/Mic. Vui lòng cấp quyền để tiếp tục.');
        setHasPermission(false);
      }
    };

    getMedia();

    // 3. Hàm dọn dẹp (Cleanup function) sẽ chạy khi Component bị hủy (thoát trang)
    return () => {
      // Tắt camera từ Ref (luôn chứa giá trị mới nhất)
      if (streamRef.current) {
        streamRef.current.getTracks().forEach(track => {
          track.stop(); // Lệnh này tắt đèn camera vật lý
        });
        streamRef.current = null;
        console.log("Đã ngắt kết nối Camera/Mic thành công.");
      }
    };
  }, []);

  const handleStartExam = () => {
    if (hasPermission && isAgreed) {
        // Chuyển sang trang làm bài thi
        navigate(`/candidate/exam/${id}`);
    }
  };

  return (
    <div className="min-h-screen bg-[#F6F7F8] flex flex-col font-sans text-[#121417]">
      {/* (Optional) Navbar - Nếu bạn dùng Layout thì cái này có thể bỏ */}
      {/* <Navbar /> */}

      <main className="flex-grow flex items-center justify-center p-4 sm:p-8">
        <div className="w-full max-w-5xl bg-white rounded-xl shadow-lg border border-[#e5e7eb] overflow-hidden">
          
          {/* Header */}
          <div className="px-6 py-6 border-b border-[#f1f2f4]">
            <h1 className="text-2xl md:text-3xl font-bold text-[#121417] tracking-tight">Kiểm tra thiết bị</h1>
            <p className="text-[#677683] text-sm mt-2">Vui lòng đảm bảo camera và microphone hoạt động tốt trước khi bắt đầu.</p>
          </div>

          <div className="flex flex-col lg:flex-row">
            {/* LEFT COLUMN: CAMERA CHECK */}
            <div className="w-full lg:w-3/5 p-6 md:p-8 border-b lg:border-b-0 lg:border-r border-[#f1f2f4]">
              
              {/* Camera Preview Box */}
              <div className="relative w-full aspect-video bg-gray-100 rounded-lg overflow-hidden mb-6 group border border-gray-200">
                {hasPermission ? (
                    <video 
                        ref={videoRef} 
                        autoPlay 
                        muted 
                        playsInline 
                        className="w-full h-full object-cover transform scale-x-[-1]" // Lật ngược gương cho tự nhiên
                    />
                ) : (
                    <div className="absolute inset-0 flex flex-col items-center justify-center z-10 bg-black/5">
                        <div className="animate-pulse"><IconCamera /></div>
                        <p className="mt-4 text-gray-500 font-medium">{errorMsg || 'Đang kết nối camera...'}</p>
                    </div>
                )}
              </div>

              {/* Device Status */}
              <div className="flex flex-col sm:flex-row gap-4 justify-between items-center bg-[#F9FAFB] p-4 rounded-lg border border-[#f1f2f4]">
                {/* Camera Status */}
                <div className="flex items-center gap-3">
                  <div className={`flex items-center justify-center w-10 h-10 rounded-full ${hasPermission ? 'bg-green-100 text-green-600' : 'bg-red-100 text-red-600'}`}>
                    <IconCheckCircle />
                  </div>
                  <div>
                    <p className="text-sm font-bold text-[#121417]">Camera</p>
                    <p className={`text-xs font-medium ${hasPermission ? 'text-green-600' : 'text-red-500'}`}>
                        {hasPermission ? 'Đã kết nối' : 'Chưa kết nối'}
                    </p>
                  </div>
                </div>

                <div className="hidden sm:block w-px h-8 bg-gray-300"></div>

                {/* Mic Status (Giả lập Visualizer) */}
                <div className="flex items-center gap-3 w-full sm:w-auto">
                  <div className="flex items-center justify-center w-10 h-10 rounded-full bg-blue-50 text-blue-600">
                    <IconMic />
                  </div>
                  <div className="flex-1">
                    <p className="text-sm font-bold text-[#121417]">Microphone</p>
                    <div className="flex items-end gap-1 h-5 mt-1">
                      {/* Animation bars */}
                      <div className="w-1 bg-blue-500 rounded-full h-2 animate-bounce" style={{animationDelay: '0.1s'}}></div>
                      <div className="w-1 bg-blue-500 rounded-full h-4 animate-bounce" style={{animationDelay: '0.3s'}}></div>
                      <div className="w-1 bg-blue-500 rounded-full h-3 animate-bounce" style={{animationDelay: '0.2s'}}></div>
                      <div className="w-1 bg-blue-500 rounded-full h-5 animate-bounce" style={{animationDelay: '0.4s'}}></div>
                      <div className="w-1 bg-blue-500 rounded-full h-2 animate-bounce" style={{animationDelay: '0.1s'}}></div>
                      <span className="text-xs text-gray-500 ml-2 whitespace-nowrap">Đang thử...</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT COLUMN: REGULATIONS */}
            <div className="w-full lg:w-2/5 bg-white">
              <div className="p-6 md:p-8 h-full flex flex-col">
                <h3 className="text-lg font-bold text-[#121417] mb-6 flex items-center gap-2">
                  <IconWarning /> Quy định phòng thi
                </h3>
                
                <div className="flex flex-col gap-6 flex-grow">
                  {/* Rule 1 */}
                  <div className="flex gap-4 items-start">
                    <div className="w-10 h-10 shrink-0 flex items-center justify-center rounded-lg bg-red-50 text-red-500">
                      <IconHeadsetOff />
                    </div>
                    <div>
                      <p className="font-semibold text-[#121417] text-sm">Không sử dụng tai nghe</p>
                      <p className="text-xs text-gray-500 mt-1">Thí sinh không được phép đeo tai nghe trong suốt quá trình làm bài.</p>
                    </div>
                  </div>

                  {/* Rule 2 */}
                  <div className="flex gap-4 items-start">
                    <div className="w-10 h-10 shrink-0 flex items-center justify-center rounded-lg bg-red-50 text-red-500">
                      <IconTabOff />
                    </div>
                    <div>
                      <p className="font-semibold text-[#121417] text-sm">Không chuyển tab trình duyệt</p>
                      <p className="text-xs text-gray-500 mt-1">Hệ thống sẽ ghi nhận và cảnh báo nếu bạn rời khỏi màn hình thi.</p>
                    </div>
                  </div>

                  {/* Rule 3 */}
                  <div className="flex gap-4 items-start">
                    <div className="w-10 h-10 shrink-0 flex items-center justify-center rounded-lg bg-blue-50 text-blue-600">
                      <IconFace />
                    </div>
                    <div>
                      <p className="font-semibold text-[#121417] text-sm">Giữ khuôn mặt trong khung hình</p>
                      <p className="text-xs text-gray-500 mt-1">Đảm bảo khuôn mặt luôn hiển thị rõ ràng trước camera.</p>
                    </div>
                  </div>

                   {/* Rule 4 */}
                   <div className="flex gap-4 items-start">
                    <div className="w-10 h-10 shrink-0 flex items-center justify-center rounded-lg bg-red-50 text-red-500">
                      <IconPersonOff />
                    </div>
                    <div>
                      <p className="font-semibold text-[#121417] text-sm">Không có người khác</p>
                      <p className="text-xs text-gray-500 mt-1">Nghiêm cấm sự xuất hiện hoặc hỗ trợ từ người khác trong phòng thi.</p>
                    </div>
                  </div>
                </div>

                {/* Footer Actions */}
                <div className="mt-8 pt-6 border-t border-[#f1f2f4]">
                  
                  {/* CHECKBOX: Thêm focus:ring-0 để bỏ viền xanh khi bấm */}
                  <label className="flex items-start gap-3 cursor-pointer group mb-6 select-none relative">
                    <div className="relative flex items-center">
                      <input 
                        type="checkbox" 
                        checked={isAgreed}
                        onChange={(e) => setIsAgreed(e.target.checked)}
                        className="peer w-5 h-5 cursor-pointer appearance-none rounded border border-gray-300 checked:!bg-blue-600 checked:!border-blue-600 transition-all bg-white focus:ring-0 focus:outline-none" 
                      />
                      {/* SVG dấu tích */}
                      <svg className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-3.5 h-3.5 text-white pointer-events-none opacity-0 peer-checked:opacity-100 transition-opacity" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <span className="text-sm font-medium text-[#121417] group-hover:text-blue-600 transition-colors">
                        Tôi đồng ý với quy định và sẵn sàng làm bài thi.
                    </span>
                  </label>

                  {/* BUTTON: Thêm !bg... và focus:!bg... để ép màu xanh tuyệt đối */}
                  <button 
                    onClick={handleStartExam}
                    disabled={!hasPermission || !isAgreed}
                    className={`w-full font-bold py-3 px-6 rounded-lg transition-all duration-200 flex items-center justify-center gap-2 shadow-sm focus:outline-none
                        ${(!hasPermission || !isAgreed) 
                            ? 'bg-gray-300 text-gray-500 cursor-not-allowed' 
                            : '!bg-[#2563EB] hover:!bg-blue-700 active:!bg-blue-800 focus:!bg-[#2563EB] text-white'
                        }`}
                  >
                    <span>Vào phòng thi</span>
                    <IconArrowForward />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <footer className="py-6 text-center">
        <p className="text-xs text-[#677683]">© 2024 SkillMatch. Nền tảng tuyển dụng thông minh.</p>
      </footer>
    </div>
  );
}